import request from '@/utils/request'

export function login(username, password) {
    return request({
        url: '/v2/login/login',
        method: 'post',
        data: {
            username,
            password
        }
    })
}

export function logout() {
    return request({
        url: '/v2/user/logout',
        method: 'get'
    })
}

export function isAdmin(params) {
    return request({
        url: '/v2/user/isAdmin',
        method: 'post',
        data: params
    })
}

export function isManager(params) {
    return request({
        url: '/v2/user/isManager',
        method: 'post',
        data: params
    })
}

export function isTokenCheck(params) {
    return request({
        url: '/v2/user/isTokenCheck',
        method: 'post',
        data: params
    })
}

export function loginAdmin(params) {
    return request({
        url: '/v2/login/loginAdmin',
        method: 'post',
        data: params
    })
}